import React from 'react';
import { useI18n } from 'hooks/useI18n';
import { Row, Col, Tabs } from 'antd';
import { User, User2 } from 'lucide-react'; // Use existing Lucide icons
import CustomerListFunctional from './customer-list-functional';

const CustomerListTab = () => {
	const { t } = useI18n();

	const tabItems = [
		{
			label: (
				<span>
					<User size={16} style={{ marginRight: 6 }} />
					{t('customers.male')}
				</span>
			),
			key: 'male',
			children: <CustomerListFunctional isFemale={false} />,
		},
		{
			label: (
				<span>
					<User2 size={16} style={{ marginRight: 6 }} />
					{t('customers.female')}
				</span>
			),
			key: 'female',
			children: <CustomerListFunctional isFemale={true} />,
		},
	];

	return (
		<Row className="customer-tab-container" style={{ height: '80%' }}>
			<Col xl={24} className="container">
				<Tabs defaultActiveKey="male" destroyInactiveTabPane items={tabItems} />
			</Col>
		</Row>
	);
};

export default CustomerListTab;
